import { useContext } from 'react';

import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import SearchToggle from 'components/Search/SearchToggle';
import Logo from 'components/Logo/Logo';

import useIsMobile from 'hooks/useIsMobile';

import PageSettingsContext from 'modules/App/PageSettingsContext';

import Notice from './components/Notice/Notice';
import AppMenu from './components/AppMenu/AppMenu';
import Map from './components/Map/Map';

function Header() {
  const isMobile = useIsMobile();

  const {
    value: {
      headerTitle,
      headerSubtitle,
      headerExtraContent,
      headerElevation,
    },
  } = useContext(PageSettingsContext);

  return (
    <>
      <Notice />
      <div style={{ paddingTop: isMobile ? 50 : 0 }}>
        <Card
          elevation={headerElevation ? 9 : 0}
          sx={{
            position: {
              xs: 'fixed',
              sm: 'static',
            },
            width: '100%',
            height: {
              xs: 50,
              sm: 'auto',
            },
            top: 0,
            zIndex: (theme) => theme.zIndex.appBar,
          }}
        >
          <Container
            sx={{
              my: isMobile ? 0 : 4,
              flexGrow: 1,
              '& .MuiToolbar-gutters': {
                px: 0,
              },
            }}
          >
            <Toolbar variant={isMobile ? 'dense' : 'regular'}>
              <Box
                sx={{
                  display: 'block',
                  flexShrink: 0,
                }}
              >
                <Logo
                  isMobile={isMobile}
                  title={headerTitle}
                  subtitle={headerSubtitle}
                  extraContent={headerExtraContent}
                />
              </Box>
              <Box
                className="hide-on-print"
                sx={{
                  display: 'flex',
                  flexGrow: 1,
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <Box sx={{ mr: 2, color: 'text.secondary' }}>
                  <Map />
                </Box>
                <Box sx={{ mr: 1, color: 'text.secondary' }}>
                  <SearchToggle />
                </Box>
                {!isMobile && <Divider sx={{ mr: 1, ml: 2 }} orientation="vertical" flexItem />}
                <AppMenu isMobile={isMobile} />
              </Box>
            </Toolbar>
          </Container>
        </Card>
      </div>
    </>
  );
}

export default Header;
